import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import * as Data from "../data";

var LetterHelper =
/*#__PURE__*/
function () {
  function LetterHelper() {
    _classCallCheck(this, LetterHelper);
  }

  _createClass(LetterHelper, [{
    key: "UploadLetter",
    value: function UploadLetter(blob, title, managementCompanyId, propertyId, statusId, moduleName, moduleId, documentType, subModuleName, subModuleId, merge, moduleUniqueName) {
      var file = new File([blob], title);
      return Data.Files.Upload([file], managementCompanyId, propertyId, title, statusId, moduleName, moduleId, documentType, subModuleName, subModuleId, merge, moduleUniqueName, false);
    }
  }, {
    key: "PopulateTableData",
    value: function PopulateTableData(letter, tableName, data) {
      var contentTable = letter.content.find(function (x) {
        return x.name == tableName;
      });
      if (contentTable) contentTable.data = data;
    }
  }, {
    key: "PreloadPrompt",
    value: function PreloadPrompt(prompt, preloadFunctions) {
      if (preloadFunctions[prompt.placeHolder]) return preloadFunctions[prompt.placeHolder];else return "";
    }
  }]);

  return LetterHelper;
}();

export default new LetterHelper();